import { Injectable, inject } from '@angular/core';
import { RequestBuilder } from '@hereisyourgitanton/crm-api2';
import { HttpClient, HttpParams } from '@angular/common/http';
import { OrganizationTypeResponseDto } from '../schemas/organization-type-response.dto';
import { CreateOrganizationTypeRequestDto } from '../schemas/create-organization-type-request.dto';
import { UpdateOrganizationTypeRequestDto } from '../schemas/update-organization-type-request.dto';
import { TRADGINE_DATA_API_BASE_URL } from '../api-base-url.token';

@Injectable({
    providedIn: 'root',
})
export class OrganizationTypeAdminApi {
    private readonly builder = new RequestBuilder(inject(HttpClient));
    private readonly controllerUrl = `${
        inject(TRADGINE_DATA_API_BASE_URL)
    }/OrganizationTypeAdmin`;

    getAll() {
        return this.builder
            .url(`${this.controllerUrl}/getAll`)
            .get()
            .json<OrganizationTypeResponseDto[]>()
            .build()
            .send();
    }

    getById(id: number) {
        return this.builder
            .url(`${this.controllerUrl}/getById`)
            .get()
            .json<OrganizationTypeResponseDto>()
            .withHttpParams(new HttpParams().set('id', id))
            .build()
            .send();
    }

    create(payload: CreateOrganizationTypeRequestDto) {
        return this.builder
            .url(`${this.controllerUrl}/create`)
            .post(payload)
            .json<OrganizationTypeResponseDto>()
            .build()
            .send();
    }

    update(payload: UpdateOrganizationTypeRequestDto) {
        return this.builder
            .url(`${this.controllerUrl}/update`)
            .put(payload)
            .json<OrganizationTypeResponseDto>()
            .build()
            .send();
    }

    delete(id: number) {
        return this.builder
            .url(`${this.controllerUrl}/delete`)
            .delete()
            .text()
            .withHttpParams(new HttpParams().set('id', id))
            .build()
            .send();
    }
}
